"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import InhouseTrainingModal from "../../components/forms/inhouse-training-modal";

const InhouseTrainingPage: React.FC = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const router = useRouter();

	useEffect(() => {
		setModalOpen(true);
	}, []);

	const handleCloseModal = () => {
		setModalOpen(false);
		router.push("/");
	};

	return (
		<>
			<div className="flex items-center justify-center min-h-screen">
				<div className="text-center">
					<h1 className="text-xl font-semibold mb-4">Đào tạo Inhouse</h1>
					<p className="text-gray-600 mb-4">
						Mở form đăng ký đào tạo Inhouse...
					</p>
				</div>
			</div>

			<InhouseTrainingModal open={modalOpen} onClose={handleCloseModal} />
		</>
	);
};

export default InhouseTrainingPage;
